import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

import MainContainer from "../../components/MainContainer/MainContainer";
import SEO from "../../components/SEO/SEO";
import LazyImage from "../../components/utils/LazyImage";
import LazyModalImage from "../../components/utils/LazyModalImage";
import {
  GalleryContainer,
  GalleryHeader,
  FilterButtons,
  FilterButton,
  GalleryGrid,
  GalleryItem,
  LoadMoreButton,
  EmptyState,
  ImageModal,
  ModalContent,
  CloseButton,
} from "./GalleryPage.styles";

import LashImg1 from "../../assets/images/lash.jpg";
import LashImg2 from "../../assets/images/lash2.jpg";
import LashImg3 from "../../assets/images/lash3.jpg";
import LashImg4 from "../../assets/images/lash4.jpg";
import LashImg5 from "../../assets/images/lash5.jpg";
import LashImg6 from "../../assets/images/lash6.jpg";
import BrowImg1 from "../../assets/images/brow.jpg";
import BrowImg2 from "../../assets/images/brow2.jpg";
import BrowImg3 from "../../assets/images/brow3.jpg";
import BrowImg4 from "../../assets/images/brow4.jpg";
import BrowImg5 from "../../assets/images/brow5.jpg";
import BrowImg6 from "../../assets/images/brow6.jpg";

const galleryData = [
  {
    id: 1,
    title: "Lash Lift Classic",
    description: "Prirodno podizanje trepavica za svakodnevni izgled",
    category: "trepavice",
    image: LashImg1,
  },
  {
    id: 2,
    title: "Lash Lift Volume",
    description: "Volumen efekat za dramatičniji izgled",
    category: "trepavice",
    image: LashImg2,
  },
  {
    id: 3,
    title: "Lash Lift Natural",
    description: "Prirodan zavoj za definisane trepavice",
    category: "trepavice",
    image: LashImg3,
  },
  {
    id: 4,
    title: "Lash Lift Dramatic",
    description: "Dramatičan lift za spektakularan pogled",
    category: "trepavice",
    image: LashImg4,
  },
  {
    id: 5,
    title: "Lash Lift Elegant",
    description: "Elegantan lift za posebne prilike",
    category: "trepavice",
    image: LashImg5,
  },
  {
    id: 6,
    title: "Lash Lift Perfect",
    description: "Savršen zavoj za maksimalan efekat",
    category: "trepavice",
    image: LashImg6,
  },
  {
    id: 7,
    title: "Brow Lift Classic",
    description: "Klasičan lift obrva za prirodan izgled",
    category: "obrve",
    image: BrowImg1,
  },
  {
    id: 8,
    title: "Brow Lift Lamination",
    description: "Laminacija obrva za savršen oblik",
    category: "obrve",
    image: BrowImg2,
  },
  {
    id: 9,
    title: "Brow Lift Shaping",
    description: "Oblikovanje obrva sa lift efektom",
    category: "obrve",
    image: BrowImg3,
  },
  {
    id: 10,
    title: "Brow Lift Definition",
    description: "Definisanje obrva za izražajniji pogled",
    category: "obrve",
    image: BrowImg4,
  },
  {
    id: 11,
    title: "Brow Lift Styling",
    description: "Stilizovanje obrva sa trajnim efektom",
    category: "obrve",
    image: BrowImg5,
  },
  {
    id: 12,
    title: "Brow Lift Professional",
    description: "Profesionalan lift za savršene obrve",
    category: "obrve",
    image: BrowImg6,
  },
];

const GalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("sve");

  const [filteredItems, setFilteredItems] = useState(galleryData);
  const [visibleItems, setVisibleItems] = useState(9);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const categories = [
    { value: "sve", label: "Sve" },
    { value: "trepavice", label: "Trepavice" },
    { value: "obrve", label: "Obrve" },
  ];

  useEffect(() => {
    if (selectedCategory === "sve") {
      setFilteredItems(galleryData);
    } else {
      setFilteredItems(
        galleryData.filter((item) => item.category === selectedCategory)
      );
    }
    setVisibleItems(9);
  }, [selectedCategory]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleLoadMore = () => {
    setVisibleItems((prev) => prev + 6);
  };

  const handleImageClick = (item) => {
    setSelectedImage(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedImage(null), 300);
  };

  const displayedItems = filteredItems.slice(0, visibleItems);
  const hasMore = visibleItems < filteredItems.length;

  return (
    <MainContainer>
      <SEO
        title="Galerija radova"
        description="Pogledajte galeriju radova — Lash Lift i Brow Lift transformacije iz MITOVKA BeautySpot-a."
        path="/galerija"
      />

      <GalleryHeader>
        <h1>Galerija Radova</h1>
        <p>
          Istražite deo moje dosadašnje kolekcije radova i uverite se u
          rezultate koji ovi kursevi pružaju.
        </p>
      </GalleryHeader>

      <GalleryContainer>
        <FilterButtons>
          {categories.map((category) => (
            <FilterButton
              key={category.value}
              $active={selectedCategory === category.value}
              onClick={() => handleCategoryChange(category.value)}
            >
              {category.label}
            </FilterButton>
          ))}
        </FilterButtons>

        {displayedItems.length > 0 ? (
          <>
            <GalleryGrid>
              {displayedItems.map((item, index) => (
                <GalleryItem
                  key={item.id}
                  $delay={index * 100}
                  onClick={() => handleImageClick(item)}
                >
                  <LazyImage src={item.image} alt={item.title} />
                  {/* <GalleryOverlay>
                    <div className="category">
                      {
                        categories.find((cat) => cat.value === item.category)
                          ?.label
                      }
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </GalleryOverlay> */}
                </GalleryItem>
              ))}
            </GalleryGrid>

            {hasMore && (
              <LoadMoreButton onClick={handleLoadMore}>
                Učitaj još
              </LoadMoreButton>
            )}
          </>
        ) : (
          <EmptyState>
            <h3>Nema rezultata</h3>
            <p>
              Nema dostupnih radova u odabranoj kategoriji. Pokušajte sa drugom
              kategorijom.
            </p>
          </EmptyState>
        )}
      </GalleryContainer>

      <ImageModal $isOpen={isModalOpen} onClick={handleCloseModal}>
        <ModalContent
          $isOpen={isModalOpen}
          onClick={(e) => e.stopPropagation()}
        >
          <CloseButton onClick={handleCloseModal}>
            <FaTimes />
          </CloseButton>
          {selectedImage && (
            <LazyModalImage
              src={selectedImage.image}
              alt={selectedImage.title}
            />
          )}
        </ModalContent>
      </ImageModal>
    </MainContainer>
  );
};

export default GalleryPage;
